module.exports = {
  name: '大門資料',
  schema: {
    type: 'Object',
    contents: {
      card: { type: 'String', name: '卡號' },
      stafferRef: {
        type: 'ObjectId',
        name: '人員',
        reference: 'users',
        refKeys: ['name'],
      },
      time: {
        type: 'Date',
        name: '時間',
        format: 'YYYY/MM/DD HH:mm:ss',
        required: true,
      },
      source: { type: 'String', name: '來源', options: ['刷卡', '輸入'] },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'stafferRef', width: 100 },
        { key: 'time', width: 200 },
        { key: 'source' },
      ],
    },
    editor: {
      groups: [
        {
          name: '系統資料',
          rows: [
            [{ key: 'card' }],
            [{ key: 'stafferRef' }],
            [{ key: 'time' }],
            [{ key: 'source' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/gateRecords.js